import { atom, selector } from 'recoil';
import { ConfigurationTriggerType } from '../types/maintenances';

export const maintenanceConfigurationsReloadListState = atom<boolean>({
  key: 'app.maintenaceConfigurations.reload',
  default: false,
});

export const maintenanceConfigurationsFiltersState = atom<{
  page: number;
  triggerType?: ConfigurationTriggerType;
  maintenanceTypeId?: string;
  search: string;
}>({
  key: 'app.maintenaceConfigurations.filters',
  default: {
    page: 1,
    triggerType: undefined,
    maintenanceTypeId: undefined,
    search: '',
  },
});

export const maintenaceConfigurationsHasAnyFilterState = selector<boolean>({
  key: 'app.maintenaceConfigurations.filters.any',
  get: ({ get }) => {
    const filters = get(maintenanceConfigurationsFiltersState);
    const hasTriggerTypeFilter = filters.triggerType !== undefined;
    const hasMaintenanceTypeIdFilter = filters.maintenanceTypeId !== undefined;

    return hasTriggerTypeFilter || hasMaintenanceTypeIdFilter;
  },
});
